function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P7Main = function P7Main(_ref) {
  var page = _ref.page;
  var thisPage = 3;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p7-title').addClass('p7-title__active');
      }, 1500), setTimeout(function () {
        $('.p7-title-m').addClass('p7-title-m__active');
      }, 1500), setTimeout(function () {
        $('.p7-line1').addClass('p7-line1__active');
        $('.p7-line2').addClass('p7-line2__active');
      }, 3500), setTimeout(function () {
        $('.p7-sub-title').addClass('p7-sub-title__active');
      }, 2500)]);
    } else {
      $('.p7-title').removeClass('p7-title__active');
      $('.p7-title-m').removeClass('p7-title-m__active');
      $('.p7-sub-title').removeClass('p7-sub-title__active');
      $('.p7-line1').removeClass('p7-line1__active');
      $('.p7-line2').removeClass('p7-line2__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/posillico-s-wash-plant-is-at-the-forefront-of-sustainable-soil@2x.png",
    className: "p7-title"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/mobile-posillico-s-wash-plant-is-at-the-forefront-of-sustainable-soil@3x.png",
    className: "p7-title-m"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/providing-waste-disposal-services-including@3x.png",
    className: "p7-sub-title"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/thick-line@3x.png",
    className: "p7-line1"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p7/thick-line@3x.png",
    className: "p7-line2"
  }));
};
export default P7Main;